import { createTheme, Theme } from '@mui/material';
 
declare module '@mui/material/styles' {
  interface ComponentNameToClassKey {
    MuiLoadingButton: any;
  }
  interface Components {
    MuiLoadingButton?: {
      styleOverrides?: any;
    };
  }
}
 
export const theme: Theme = createTheme({
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true
      },
      styleOverrides: {
        root: {
          variants: [
            {
              props: { variant: 'primary', size: 'md' },
              style: {
                minWidth: '120px',
                minHeight: '44px',
                width: 'fit-content',
                padding: '12px 32px 12px 32px',
                gap: '6px',
                borderRadius: '9999px',
                backgroundColor: '#1460AA',
                textTransform: 'none',
                fontWeight: 700,
                lineHeight: '20px',
                fontSize: '16px',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                color: '#FFFFFF',
                letterSpacing: '0px',
 
                '@media(max-width: 600px)': {
                  width: '100%'
                  // maxWidth: 'fit-content'
                },
                '&:hover': {
                  backgroundColor: '#003D78'
                },
                '&:active': {
                  backgroundColor: '#002345'
                },
                '&:disabled': {
                  backgroundColor: '#D6D7D9',
                  color: '#6D6D6F'
                },
                '&:focus-visible': {
                  border: '1px solid #333333'
                }
              }
            },
            {
              props: { variant: 'primary', size: 'xl' },
              style: {
                minWidth: '120px',
                width: 'fit-content',
                padding: '12px 32px 12px 32px',
                gap: '6px',
                borderRadius: '24px',
                backgroundColor: '#1460AA',
                textTransform: 'none',
                fontWeight: 700,
                lineHeight: '20px',
                fontSize: '16px',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                color: '#FFFFFF',
                letterSpacing: '0px',
 
                '@media(max-width: 600px)': {
                  width: '100%'
                },
                '&:focus-visible': {
                  border: '1px solid #333333'
                },
                '& .MuiButton-startIcon, & .MuiButton-endIcon': {
                  '& img, & svg': {
                    width: '16px',
                    height: '16px',
                    objectFit: 'contain'
                  }
                },
                '&:hover': {
                  backgroundColor: '#003D78'
                },
                '&:active': {
                  backgroundColor: '#002345'
                },
                '&:disabled': {
                  backgroundColor: '#D6D7D9',
                  color: '#6D6D6F'
                }
              }
            },
            {
              props: { variant: 'primary', size: 'xs' },
              style: {
                minWidth: '120px',
                width: 'fit-content',
                borderRadius: '16px',
                padding: '5px 16px 5px 16px',
                gap: '6px',
                backgroundColor: '#1460AA',
                textTransform: 'none',
                fontWeight: 700,
                lineHeight: '20px',
                fontSize: '14px',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                color: '#FFFFFF',
                letterSpacing: '0px',
 
                '@media(max-width: 600px)': {
                  width: '100%',
                  maxWidth: 'fit-content'
                },
                '&:hover': {
                  backgroundColor: '#003D78'
                },
                '&:active': {
                  backgroundColor: '#002345'
                },
                '&:disabled': {
                  backgroundColor: '#D6D7D9',
                  color: '#6D6D6F'
                },
                '&:focus-visible': {
                  border: '1px solid #333333'
                }
              }
            },
            {
              props: { variant: 'primary', size: 'sm' },
              style: {
                minWidth: '120px',
                width: 'fit-content',
                borderRadius: '16px',
                padding: '5px 16px 5px 16px',
                gap: '6px',
                backgroundColor: '#1460AA',
                textTransform: 'none',
                fontWeight: 700,
                lineHeight: '20px',
                fontSize: '14px',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                color: '#FFFFFF',
                letterSpacing: '0px',
 
                '@media(max-width: 600px)': {
                  width: '100%',
                  maxWidth: 'fit-content'
                },
                '& .MuiButton-end': {
                  height: '16px',
                  width: '16px'
                },
                '&:hover': {
                  backgroundColor: '#003D78'
                },
                '&:active': {
                  backgroundColor: '#002345'
                },
                '&:disabled': {
                  backgroundColor: '#D6D7D9',
                  color: '#6D6D6F'
                },
                '&:focus-visible': {
                  border: '1px solid #333333'
                }
              }
            },
            {
              props: { variant: 'secondary', size: 'md' },
              style: {
                minWidth: '120px',
                width: 'fit-content',
                padding: '12px 32px 12px 32px',
                gap: '6px',
                border: '1px solid #1460AA',
                borderRadius: '24px',
                backgroundColor: '#FFFFFF',
                textTransform: 'none',
                fontWeight: 700,
                lineHeight: '20px',
                fontSize: '16px',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                color: '#1460AA',
                letterSpacing: '0px',
 
                '@media(max-width: 600px)': {
                  width: '100%',
                  // maxWidth: 'fit-content'
                },
                '&:hover': {
                  borderColor:"#003D78",
                  backgroundColor: '#F9F9F9'
                },
                '&:active': {
                  color: '#002345'
                },
                '&:disabled': {
                  backgroundColor: '#EFF0F2',
                  color: '#6D6D6F'
                },
                '&:focus-visible': {
                  border: '1px solid #333333'
                }
              }
            },
            {
              props: { variant: 'secondary', size: 'xl' },
              style: {
                minWidth: '120px',
                width: 'fit-content',
                padding: '12px 32px 12px 32px',
                gap: '6px',
                border: '1px solid #1460AA',
                borderRadius: '24px',
                backgroundColor: '#FFFFFF',
                textTransform: 'none',
                fontWeight: 700,
                lineHeight: '20px',
                fontSize: '16px',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                color: '#1460AA',
                letterSpacing: '0px',
 
                '@media(max-width: 600px)': {
                  width: '100%'
                },
                '&:focus-visible': {
                  border: '1px solid #333333'
                },
                '& .MuiButton-startIcon, & .MuiButton-endIcon': {
                  '& img, & svg': {
                    width: '16px',
                    height: '16px',
                    objectFit: 'contain'
                  }
                },
                '&:hover': {
                  color: '#003D78',
                  borderColor: '#003D78'
                },
                '&:active': {
                  color: '#002345',
                  borderColor: '#002345'
                },
                '&:disabled': {
                  backgroundColor: '#D6D7D9',
                  color: '#6D6D6F',
                  '& .MuiButton-startIcon': {
                    visibility: 'hidden'
                  }
                }
              }
            },
            {
              props: { variant: 'secondary', size: 'xs' },
              style: {
                minWidth: '120px',
                width: 'fit-content',
                border: '1px solid #1460AA',
                borderRadius: '16px',
                padding: '5px 16px 5px 16px',
                gap: '6px',
                backgroundColor: '#FFFFFF',
                textTransform: 'none',
                fontWeight: 700,
                lineHeight: '20px',
                fontSize: '14px',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                color: '#1460AA',
                letterSpacing: '0px',
 
                '@media(max-width: 600px)': {
                  width: '100%',
                  maxWidth: 'fit-content'
                },
                '&:hover': {
                  color: '#003D78'
                },
                '&:active': {
                  color: '#002345'
                },
                '&:disabled': {
                  backgroundColor: '#D6D7D9',
                  color: '#6D6D6F'
                },
                '&:focus-visible': {
                  border: '1px solid #333333'
                }
              }
            },
            {
              props: { variant: 'secondary', size: 'sm' },
              style: {
                minWidth: '120px',
                width: 'fit-content',
                border: '1px soild #1460AA',
                borderRadius: '16px',
                padding: '5px 16px 5px 16px',
                gap: '6px',
                backgroundColor: '#FFFFFF',
                textTransform: 'none',
                fontWeight: 700,
                lineHeight: '20px',
                fontSize: '14px',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                color: '#1460AA',
                letterSpacing: '0px',
 
                '@media(max-width: 600px)': {
                  width: '100%',
                  maxWidth: 'fit-content'
                },
                '& .MuiButton-end': {
                  height: '16px',
                  width: '16px'
                },
                '&:hover': {
                  color: '#003D78'
                },
                '&:active': {
                  color: '#002345'
                },
                '&:disabled': {
                  backgroundColor: '#D6D7D9',
                  color: '#6D6D6F'
                },
                '&:focus-visible': {
                  border: '1px solid #333333'
                }
              }
            },
            {
              props: { variant: 'list', size: 'md' },
              style: {
                radius: '24px',
                border: '1px solid #C9CACC',
                padding: '12px 16px 12px 16px',
                backgroundColor: '#F6F6F6',
                display: 'flex',
                justifyContent: 'space-between',
                height: '48px',
                textTransform: 'none',
                fontWeight: 700,
                lineHeight: '20px',
                letterSpacing: '0px',
                fontSize: '16px',
                color: '#000000',
 
                '& .MuiButton-endIcon': {
                  height: '16px',
                  width: '16px',
                  paddingLeft: '16px'
                },
                '& .MuiButton-startIcon': {
                  height: '24px',
                  width: '24px'
                },
                '&:hover': {
                  backgroundColor: '#E2E3E5',
                  color: '#003D78',
                  border: '1px solid #003D78'
                },
                '&:active': {
                  backgroundColor: '#D6D7D9',
                  color: '#002345',
                  border: '1px solid #002345'
                },
                '&:disabled': {
                  backgroundcolor: '#EFF0F2',
                  color: '#C9CACC'
                },
                '&:focus-visible': {
                  border: '1px solid #333333'
                }
              }
            },
            {
              props: { variant: 'list', size: 'sm' },
              style: {
                radius: '16px',
                border: '1px solid #C9CACC',
                padding: '5px 12px 5px 12px',
                backgroundColor: '#F6F6F6',
                display: 'flex',
                justifyContent: 'space-between',
                height: '30px',
                textTransform: 'none',
                fontWeight: 700,
                lineHeight: '20px',
                letterSpacing: '0px',
                fontSize: '14px',
                color: '#000000',
 
                '& .MuiButton-endIcon': {
                  height: '16px',
                  width: '16px',
                  paddingLeft: '16px'
                },
                '& .MuiButton-startIcon': {
                  height: '16px',
                  width: '16px'
                },
                '&:hover': {
                  backgroundColor: '#E2E3E5',
                  color: '#003D78',
                  border: '1px solid #003D78'
                },
                '&:active': {
                  backgroundColor: '#D6D7D9',
                  color: '#002345',
                  border: '1px solid #002345'
                },
                '&:disabled': {
                  backgroundcolor: '#EFF0F2',
                  color: '#C9CACC'
                },
                '&:focus-visible': {
                  border: '1px solid #333333'
                }
              }
            },
            {
              props: { variant: 'text', size: 'sm' },
              style: {
                color: '#1460AA',
                padding: '0px',
                textTransform: 'none',
                minwidth: '93px',
                backgroundColor: 'transparent',
                fontWeight: 700,
                fontSize: '14px',
                lineHeight: '20px',
                letterSpacing: '0px',
                textAlign: 'center',
                gap: '6px',
                transition: 'none',
                '& .MuiTouchRipple-root': {
                  display: 'none',
                  animation: 'none',
                  opacity: '0',
                  backgroundColor: 'transparent'
                },
                '& .MuiButton-endIcon': {
                  '& img, & svg': {
                    height: '16px',
                    width: '16px'
                  }
                },
                '&:hover': {
                  backgroundColor: 'transparent',
                  color: '#003D78',
                  textDecoration: 'underline'
                },
                '&:active': {
                  backgroundColor: 'transparent',
                  color: '#002345',
                  textDecoration: 'underline'
                },
                '&:disabled': {
                  color: '#6D6D6F'
                }
              }
            }
          ]
        },
        text: {
          color: '#1460AA',
          padding: '0px',
          textTransform: 'none',
          minwidth: '93px',
          backgroundColor: 'transparent',
          fontWeight: 700,
          fontSize: '16px',
          lineHeight: '22px',
          letterSpacing: '0px',
          textAlign: 'center',
          gap: '6px',
          transition: 'none',
          '& .MuiTouchRipple-root': {
            display: 'none',
            animation: 'none',
            opacity: '0',
            backgroundColor: 'transparent'
          },
          '& .MuiButton-endIcon': {
            '& img, & svg': {
              height: '16px',
              width: '16px'
            }
          },
          '&:hover': {
            backgroundColor: 'transparent',
            color: '#003D78',
            textDecoration: 'underline'
          },
          '&:active': {
            backgroundColor: 'transparent',
            color: '#002345',
            textDecoration: 'underline'
          },
          '&:disabled': {
            color: '#6D6D6F'
          }
        }
      }
    },
    MuiLoadingButton: {
      styleOverrides: {
        root: {
          variants: [
            {
              props: { variant: 'primary', size: 'md' },
              style: {
                minWidth: '120px',
                height: '44px',
                width: 'fit-content',
                padding: '12px 32px 12px 32px',
                gap: '6px',
                borderRadius: '9999px',
                backgroundColor: '#1460AA',
                textTransform: 'none',
                fontWeight: 700,
                lineHeight: '20px',
                fontSize: '16px',
                color: '#FFFFFF',
                opacity:"1 !important",
                '&.MuiLoadingButton-loading': {
                  backgroundColor: '#002345 !important',
                  color: 'transparent !important',
                  pointerEvents: 'none',
                  '&:hover': {
                    backgroundColor: '#002345 !important'
                  },
                  '& .MuiCircularProgress-root': {
                    color: '#FFFFFF !important',
                    width: '28px !important',
                    height: '28px !important'
                  }
                }
              }
            },
            {
              props: { variant: 'primary', size: 'xl' },
              style: {
                minWidth: '120px',
                width: 'fit-content',
                padding: '12px 32px 12px 32px',
                gap: '6px',
                borderRadius: '24px',
                backgroundColor: '#1460AA',
                textTransform: 'none',
                fontWeight: 700,
                lineHeight: '20px',
                fontSize: '16px',
                color: '#FFFFFF',
                '&.MuiLoadingButton-loading': {
                  backgroundColor: '#002345 !important',
                  color: 'transparent !important',
                  pointerEvents: 'none',
                  '&:hover': {
                    backgroundColor: '#002345 !important'
                  },
                  '& .MuiCircularProgress-root': {
                    color: '#FFFFFF !important',
                    width: '28px !important',
                    height: '28px !important'
                  }
                }
              }
            },
            {
              props: { variant: 'primary', size: 'xs' },
              style: {
                minWidth: '120px',
                width: 'fit-content',
                borderRadius: '16px',
                padding: '5px 16px 5px 16px',
                gap: '6px',
                backgroundColor: '#1460AA',
                textTransform: 'none',
                fontWeight: 700,
                lineHeight: '20px',
                fontSize: '14px',
                color: '#FFFFFF',
                '&.MuiLoadingButton-loading': {
                  backgroundColor: '#002345 !important',
                  color: 'transparent !important',
                  pointerEvents: 'none',
                  '&:hover': {
                    backgroundColor: '#002345 !important'
                  },
                  '& .MuiCircularProgress-root': {
                    color: '#FFFFFF !important',
                    width: '20px !important',
                    height: '20px !important'
                  }
                }
              }
            },
            {
              props: { variant: 'primary', size: 'sm' },
              style: {
                minWidth: '120px',
                width: 'fit-content',
                borderRadius: '16px',
                padding: '5px 16px 5px 16px',
                gap: '6px',
                backgroundColor: '#1460AA',
                textTransform: 'none',
                fontWeight: 700,
                lineHeight: '20px',
                fontSize: '14px',
                color: '#FFFFFF',
                '&.MuiLoadingButton-loading': {
                  backgroundColor: '#002345 !important',
                  color: 'transparent !important',
                  pointerEvents: 'none',
                  '&:hover': {
                    backgroundColor: '#002345 !important'
                  },
                  '& .MuiCircularProgress-root': {
                    color: '#FFFFFF !important',
                    width: '20px !important',
                    height: '20px !important'
                  }
                }
              }
            },
            {
              props: { variant: 'secondary', size: 'md' },
              style: {
                minWidth: '120px',
                height: '44px',
                width: 'fit-content',
                padding: '12px 32px 12px 32px',
                gap: '6px',
                border: '1px solid #1460AA',
                borderRadius: '24px',
                backgroundColor: '#FFFFFF',
                textTransform: 'none',
                fontWeight: 700,
                lineHeight: '20px',
                fontSize: '16px',
                color: '#1460AA',
                opacity:"1 !important",
                '&.MuiLoadingButton-loading': {
                  backgroundColor: '#EFF0F2 !important',
                  color: 'transparent !important',
                  border: '1px solid #002345',
                  pointerEvents: 'none',
                  '&:hover': {
                    backgroundColor: '#EFF0F2 !important'
                  },
                  '& .MuiCircularProgress-root': {
                    color: '#002345 !important',
                    width: '28px !important',
                    height: '28px !important'
                  }
                }
              }
            },
            {
              props: { variant: 'secondary', size: 'xl' },
              style: {
                minWidth: '120px',
                width: 'fit-content',
                padding: '12px 32px 12px 32px',
                gap: '6px',
                border: '1px solid #1460AA',
                borderRadius: '24px',
                backgroundColor: '#FFFFFF',
                textTransform: 'none',
                fontWeight: 700,
                lineHeight: '20px',
                fontSize: '16px',
                color: '#1460AA',
                '&.MuiLoadingButton-loading': {
                  backgroundColor: '#EFF0F2 !important',
                  color: 'transparent !important',
                  border: '1px solid #002345',
                  pointerEvents: 'none',
                  '&:hover': {
                    backgroundColor: '#EFF0F2 !important'
                  },
                  '& .MuiCircularProgress-root': {
                    color: '#002345 !important',
                    width: '28px !important',
                    height: '28px !important'
                  }
                }
              }
            },
            {
              props: { variant: 'secondary', size: 'xs' },
              style: {
                minWidth: '120px',
                width: 'fit-content',
                border: '1px solid #1460AA',
                borderRadius: '16px',
                padding: '5px 16px 5px 16px',
                gap: '6px',
                backgroundColor: '#FFFFFF',
                textTransform: 'none',
                fontWeight: 700,
                lineHeight: '20px',
                fontSize: '14px',
                color: '#1460AA',
                '&.MuiLoadingButton-loading': {
                  backgroundColor: '#EFF0F2 !important',
                  color: 'transparent !important',
                  border: '1px solid #002345',
                  pointerEvents: 'none',
                  '&:hover': {
                    backgroundColor: '#EFF0F2 !important'
                  },
                  '& .MuiCircularProgress-root': {
                    color: '#002345 !important',
                    width: '20px !important',
                    height: '20px !important'
                  }
                }
              }
            },
            {
              props: { variant: 'secondary', size: 'sm' },
              style: {
                minWidth: '120px',
                width: 'fit-content',
                border: '1px solid #1460AA',
                borderRadius: '16px',
                padding: '5px 16px 5px 16px',
                gap: '6px',
                backgroundColor: '#FFFFFF',
                textTransform: 'none',
                fontWeight: 700,
                lineHeight: '20px',
                fontSize: '14px',
                color: '#1460AA',
                '&.MuiLoadingButton-loading': {
                  backgroundColor: '#EFF0F2 !important',
                  color: 'transparent !important',
                  border: '1px solid #002345',
                  pointerEvents: 'none',
                  '&:hover': {
                    backgroundColor: '#EFF0F2 !important'
                  },
                  '& .MuiCircularProgress-root': {
                    color: '#002345 !important',
                    width: '20px !important',
                    height: '20px !important'
                  }
                }
              }
            }
          ]
        }
      }
    }
  }
});
 